import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth.store';
import { useToastStore } from '@/stores/toast.store';
export const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/login',
            name: 'login',
            meta: { public: true },
            component: () => import('@/pages/LoginPage.vue'),
        },
        {
            path: '/terms',
            name: 'terms',
            meta: { public: true },
            component: () => import('@/pages/legal/TermsPage.vue'),
        },
        {
            path: '/privacy',
            name: 'privacy',
            meta: { public: true },
            component: () => import('@/pages/legal/PrivacyPage.vue'),
        },
        {
            path: '/',
            component: () => import('@/layouts/MainLayout.vue'),
            children: [
                { path: '', redirect: '/dashboard' },
                { path: 'dashboard', name: 'dashboard', component: () => import('@/pages/DashboardPage.vue') },
                { path: 'bookings', name: 'bookings', component: () => import('@/pages/BookingsPage.vue') },
                { path: 'results', name: 'results', component: () => import('@/pages/ResultsPage.vue') },
                { path: 'patients', name: 'patients', component: () => import('@/pages/PatientsPage.vue') },
                { path: 'reports', name: 'reports', component: () => import('@/pages/ReportsPage.vue') },
                { path: 'news', name: 'news', component: () => import('@/pages/NewsPage.vue') },
                { path: 'catalog', name: 'catalog', component: () => import('@/pages/CatalogPage.vue') },
                {
                    path: 'consultations',
                    name: 'consultations',
                    component: () => import('@/pages/ConsultationsPage.vue'),
                },
                {
                    path: 'feedbacks',
                    name: 'feedbacks',
                    component: () => import('@/pages/FeedbacksPage.vue'),
                },
                {
                    path: 'staff',
                    name: 'staff',
                    meta: { adminOnly: true },
                    component: () => import('@/pages/StaffPage.vue'),
                },
                {
                    path: 'settings',
                    name: 'settings',
                    component: () => import('@/pages/SettingsPage.vue'),
                },
                {
                    path: 'audit-logs',
                    name: 'audit-logs',
                    meta: { adminOnly: true },
                    component: () => import('@/pages/AuditLogPage.vue'),
                },
                {
                    path: 'zns-logs',
                    name: 'zns-logs',
                    component: () => import('@/pages/ZnsLogPage.vue'),
                },
                {
                    path: 'profile',
                    name: 'profile',
                    component: () => import('@/pages/ProfilePage.vue'),
                },
            ],
        },
        { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
    ],
});
router.beforeEach((to) => {
    const auth = useAuthStore();
    const toast = useToastStore();
    // DEBUG: log every navigation to figure out why consultations redirects
    // eslint-disable-next-line no-console
    console.log('[router]', {
        toPath: to.path,
        toName: to.name,
        matched: to.matched.map((m) => m.path),
        metaPublic: to.meta.public,
        metaAdminOnly: to.meta.adminOnly,
        isAuth: auth.isAuthenticated,
        isAdmin: auth.isAdmin,
    });
    if (to.meta.public) {
        if (auth.isAuthenticated && to.name === 'login') {
            return { name: 'dashboard' };
        }
        return true;
    }
    if (!auth.isAuthenticated) {
        return { name: 'login', query: { redirect: to.fullPath } };
    }
    if (to.meta.adminOnly && !auth.isAdmin) {
        toast.show('Bạn không có quyền truy cập trang này', 'error');
        return { name: 'dashboard' };
    }
    return true;
});
